import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal, showSignInForm } from "../../../redux/slices/formDetails";
import { updateDiscardSaveModal } from "../../../redux/slices/userActivity";
import { motion, AnimatePresence } from "framer-motion";

import styles from "./DiscardOrSaveChanges.module.css";

export const DiscardOrSaveChanges = () => {
  const dispatch = useDispatch();

  const { discardSaveModalActive } = useSelector((state) => state.userActivity);

  const handleClose = () => {
    dispatch(updateDiscardSaveModal(false));
  };

  const handleDiscard = () => {
    window.location = "/";
  };
  const handleSave = () => {
    dispatch(openModal());
    dispatch(showSignInForm());
    dispatch(updateDiscardSaveModal(false));
  };

  return (
    <>
      <AnimatePresence>
        {discardSaveModalActive && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, type: "tween", ease: "anticipate" }}
            className={styles.modal_wrapper}
            onClick={handleClose}
          >
            <motion.div
              initial={{ scale: 0.5 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.5 }}
              transition={{ duration: 0.5, type: "tween", ease: "anticipate" }}
              className={styles.content_wrapper}
              onClick={(e) => e.stopPropagation()}
            >
              <h4 className={styles.content__heading}>Would you like to save the Duonut?</h4>
              <p className={styles.content__para}>Create an account to download or publish your Duonut.</p>
              <div className={styles.content__button_wrapper}>
                <button className={`${styles.content__button} ${styles.button_discard}`} onClick={handleDiscard}>
                  Discard changes
                </button>
                <button className={`${styles.content__button} ${styles.button_save}`} onClick={handleSave}>
                  Sign in to save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
